export enum CURRENCY {
  USD = 'usd',
}

export const GENERAL_CURRENCY = CURRENCY.USD
